// helpers/users.ts
var map = {
  initial: (value) => value ? `${value.substring(0, 1)}.` : null,
  full: (value) => value ?? null,
  none: () => null
};
var parseDisplayName = (displayName) => {
  if (!displayName?.trim()) {
    return { first_name: null, middle_name: null, last_name: null };
  }
  const [first, ...rest] = displayName.trim().split(/\s+/);
  if (rest.length === 0) {
    return { first_name: first, middle_name: null, last_name: null };
  }
  const last = rest.pop();
  const middle = rest.length > 0 ? rest.join(" ") : null;
  return { first_name: first, middle_name: middle, last_name: last };
};
var userFullName = (user, options = {}) => {
  const middle = map[options?.middle ?? "full"]?.(user?.middle_name);
  return [user?.first_name, middle, user?.last_name].filter(Boolean).filter((s) => typeof s === "string").map((s) => s.trim()).filter(Boolean).join(" ");
};
var isAdmin = (user) => {
  return user?.admin === true;
};
var isOfferingOwner = (user, offeringId) => {
  return user?.roles?.offering?.[offeringId] === "owner";
};
var isIssuerOwner = (user, issuerId) => {
  return user?.roles?.issuer?.[issuerId] === "owner";
};
var isIssuerEditor = (user, issuerId) => {
  return user?.roles?.issuer?.[issuerId] === "editor";
};
var isIssuerViewer = (user, issuerId) => {
  return user?.roles?.issuer?.[issuerId] === "viewer";
};
var hasIssuerRole = (user, issuerId) => {
  return Object.keys(user?.roles?.issuer ?? {}).includes(issuerId);
};
var isAnyIssuerOwner = (user) => {
  const values = Object.values(user?.roles?.issuer ?? {});
  return values.includes("owner");
};
var isAnyIssuerEditor = (user) => {
  const values = Object.values(user?.roles?.issuer ?? {});
  return values.includes("editor");
};
var isOfferingEditor = (user, offeringId) => {
  return user?.roles?.offering?.[offeringId] === "editor";
};
var isOfferingViewer = (user, offeringId) => {
  return user?.roles?.offering?.[offeringId] === "viewer";
};
var hasOfferingRole = (user, offeringId) => {
  return Object.keys(user?.roles?.offering ?? {}).includes(offeringId);
};

export { hasIssuerRole, hasOfferingRole, isAdmin, isAnyIssuerEditor, isAnyIssuerOwner, isIssuerEditor, isIssuerOwner, isIssuerViewer, isOfferingEditor, isOfferingOwner, isOfferingViewer, parseDisplayName, userFullName };
